module.exports = __webpack_public_path__ + "static/media/cocos-island.1bc948bb.svg";